var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1547 9.60469L12.5266 5.72969C12.5172 5.66875 12.4641 5.625 12.4031 5.625H8.31563C8.25469 5.625 8.20156 5.66875 8.19219 5.72969L7.56406 9.60469C7.5625 9.61094 7.5625 9.61875 7.5625 9.625C7.5625 9.69375 7.61875 9.75 7.6875 9.75H13.0312C13.0375 9.75 13.0453 9.75 13.0516 9.74844C13.1187 9.7375 13.1656 9.67344 13.1547 9.60469ZM5.80781 5.72969C5.79844 5.66875 5.74531 5.625 5.68437 5.625H1.59687C1.53594 5.625 1.48281 5.66875 1.47344 5.72969L0.845312 9.60469C0.84375 9.61094 0.84375 9.61875 0.84375 9.625C0.84375 9.69375 0.9 9.75 0.96875 9.75H6.3125C6.31875 9.75 6.32656 9.75 6.33281 9.74844C6.40156 9.7375 6.44688 9.67344 6.43594 9.60469L5.80781 5.72969ZM4.34375 4.375H9.6875C9.69375 4.375 9.70156 4.375 9.70781 4.37344C9.77656 4.3625 9.82188 4.29844 9.81094 4.22969L9.18281 0.354687C9.17344 0.29375 9.12031 0.25 9.05937 0.25H4.97188C4.91094 0.25 4.85781 0.29375 4.84844 0.354687L4.22031 4.22969C4.21875 4.23594 4.21875 4.24375 4.21875 4.25C4.21875 4.31875 4.275 4.375 4.34375 4.375Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinted);
export default __webpack_public_path__ + "static/media/icon-minted.986e5db6a4af19df4cb59cbf87506f81.svg";
export { ForwardRef as ReactComponent };